import common from './common.json';
import helpersAndErrors from './helpersAndErrors.json';

const languages = {
  common,
  helpersAndErrors,
};

export default languages;
